import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <main className="bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-br from-[#F8FAFC] to-white py-10 md:py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111]">
            Privacy Policy
          </h1>
          <p className="mt-4 text-[#475569]">
            How we collect, use, and protect your information
          </p>
          <p className="mt-2 text-sm text-[#64748B]">
            Last updated: January 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 md:py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none text-[#475569]">
            
            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">1. Introduction</h3>
            <p>
              The Trustee for Keystone Heritage Trust trading as Transa (ABN 83 164 418 663), 
              is committed to protecting your privacy and handling personal information in accordance 
              with the <strong>Privacy Act 1988 (Cth)</strong> and the <strong>Australian Privacy Principles (APPs)</strong>.
            </p>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">2. Information We Collect</h3>
            <p>We may collect:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>business name;</li>
              <li>contact name;</li>
              <li>phone number;</li>
              <li>email address;</li>
              <li>pickup address and suburb;</li>
              <li>booking details and service preferences;</li>
              <li>uploaded photos (if provided);</li>
              <li>communications between you and Transa.</li>
            </ul>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">3. How We Collect Information</h3>
            <p>Information is collected when you:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>submit forms on our website;</li>
              <li>book a pickup;</li>
              <li>contact us by phone, email, or messaging;</li>
              <li>enter into a subscription arrangement.</li>
            </ul>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">4. How We Use Information</h3>
            <p>We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>provide and manage services;</li>
              <li>schedule pickups;</li>
              <li>communicate with you;</li>
              <li>issue invoices;</li>
              <li>improve our services;</li>
              <li>comply with legal obligations.</li>
            </ul>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">5. Disclosure of Information</h3>
            <p>We may disclose information to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>employees or contractors assisting with service delivery;</li>
              <li>IT and service providers;</li>
              <li>regulators or authorities where required by law.</li>
            </ul>
            <p className="mt-2"><strong>We do not sell personal information.</strong></p>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">6. Data Storage & Security</h3>
            <p>We take reasonable steps to protect personal information from misuse, loss, and unauthorised access.</p>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">7. Access & Correction</h3>
            <p>You may request access to or correction of your personal information by contacting Transa.</p>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">8. Cookies & Website Analytics</h3>
            <p>Our website may use cookies or analytics tools to improve functionality and user experience.</p>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">9. Complaints</h3>
            <p>
              Privacy complaints may be directed to Transa at <a href="mailto:hello@transa.com.au" className="text-[#0D9488] hover:underline">hello@transa.com.au</a>. 
              If unresolved, complaints may be escalated to the Office of the Australian Information Commissioner (OAIC).
            </p>

            <h3 className="text-xl font-semibold text-[#111111] mt-8 mb-4">10. Changes to this Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. The latest version 
              will be published on the Transa website.
            </p>

            {/* Footer Note */}
            <div className="mt-12 pt-8 border-t border-[#E2E8F0]">
              <p className="text-sm text-[#64748B]">
                For our full Terms & Conditions, please visit our <Link to="/terms" className="text-[#0D9488] hover:underline">Terms & Conditions page</Link>.
              </p>
              <p className="text-sm text-[#94A3B8] mt-4">
                Transa is a registered business name of the Trustee for Keystone Heritage Trust (ABN 83 164 418 663)
              </p>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPage;
